import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";
import { cn } from "#lib/utils";

const kbdVariants = cva(
  "pointer-events-none inline-flex h-[var(--key-h)] min-w-[var(--key-h)] shrink-0 items-center justify-center rounded-sm px-1.5 font-sans text-label select-none",
  {
    variants: {
      variant: {
        // On the main panel, a menu or a tag row.
        muted: "bg-muted font-medium text-muted-foreground",
        // On a filled button, where the label colour carries over.
        keycap: "bg-keycap",
      },
    },
    defaultVariants: {
      variant: "muted",
    },
  },
);

function Kbd({
  className,
  variant = "muted",
  ...props
}: React.ComponentProps<"kbd"> & VariantProps<typeof kbdVariants>) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(kbdVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Kbd };
